<template>
  <section
    class="component-sue7nhwz"
    resmed-component-name="product_manual_list_recently_viewed"
    v-if="manuals.length"
  >
    <div class="component is-active">
      <div class="container mb-3">
        <h2 class="text-center">Recently viewed</h2>
      </div>

      <div style="overflow: hidden" class="swiper-wrapper">
        <div class="swiper container">
          <div class="row">
            <div
              class="col col-md-10 offset-md-1 col-lg-12 offset-lg-0"
              style="padding: 0"
            >
              <div class="seek">
                <div
                  class="seek-wrapper"
                  v-show="
                    ['md', 'lg', 'xl'].includes($root.mode) &&
                    manuals.length > 4
                  "
                >
                  <a
                    ref="swiperButtonPrev"
                    href="#"
                    class="btn navigation-icon left-caret swiper-button-prev"
                  ></a>
                  <a
                    ref="swiperButtonNext"
                    href="#"
                    class="btn navigation-icon right-caret swiper-button-next"
                  ></a>
                </div>

                <div
                  ref="swiperContainer"
                  class="stage swiper-container"
                  :class="`-mode-${[$root.mode]}`"
                >
                  <div
                    class="items swiper-wrapper"
                    :class="{ '-justify-content-center': manuals.length < 4 }"
                  >
                    <div
                      class="item swiper-slide mb-3 mb-md-0"
                      v-for="(manual, mIdx) in manuals"
                    >
                      <div
                        class="card"
                        :class="manual.product_type"
                        :style="{
                          'border-top-color':
                            manual.product_type_color || 'grey',
                        }"
                      >
                        <div class="content">
                          <p class="category-name">
                            {{ manual.product_type_label }}
                          </p>
                          <h3>{{ manual.title }}</h3>
                          <ul>
                            <li v-for="productUse in manual.product_uses">
                              {{ productUse }}
                            </li>
                          </ul>

                          <div
                            class="action-bar"
                            v-if="manual.cta.files.length >= 1"
                          >
                            <div>
                              <div class="tooltip">
                                <div class="content">
                                  <ul>
                                    <li v-for="file in manual.cta.files">
                                      <a
                                        class="
                                          btn
                                          cta-plain
                                          text-red
                                          icon
                                          right-arrow
                                        "
                                        :href="file.file"
                                        target="_blank"
                                        >{{ file.language }}</a
                                      >
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <a
                              @click.capture="
                                copyManualLink(
                                  manual.cta.files[0].file,
                                  $refs.manualShareLinkEl[mIdx]
                                )
                              "
                              :key="manual.multisite_id"
                              ref="manualShareLinkEl"
                              href="javascript:void(0);"
                              class="btn cta-plain text-red"
                            >
                              <img src="@/assets/images/icon-copy-link.svg" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-show="
              (['xs', 'sm'].includes($root.mode) && manuals.length > 1) ||
              ($root.mode === 'md' && manuals.length > 2) ||
              (['lg', 'xl'].includes($root.mode) && manuals.length > 4)
            "
          >
            <div class="col">
              <div ref="swiperPagination" class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";
import wpApi from "../../services/wpApi";

export default {
  name: "component-sue7nhwz", // product_manual_list_recently_viewed
  data() {
    return {
      slider: undefined,
      loading: false,
      manuals: [],
      colors: {},
    };
  },
  mixins: [helper],
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
    copyManualLink(textToCopy, el) {
      this.$copyText(textToCopy)
        .then(() => {
          $(el)
            .addClass("shadow-pulse")
            .on("animationend", () => $(el).removeClass("shadow-pulse"));
        })
        .catch((e) => console.error(e));
    },
  },
  mounted() {
    this.loading = true;
    let ids = [];

    try {
      ids = JSON.parse(
        localStorage.getItem("recently-viewed-product-manuals") || "[]"
      );
    } catch (e) {
      ids = [];
    }

    wpApi.getProductManuals({ multisite_aware_ids: ids.length ? ids : ["blog:,manual:"] })
      .then((response) => {
        this.manuals = response.data.manuals;
        this.$nextTick(() => {
          this.swhReload();
        });
      })
      .catch((e) => {
        console.error(e);
        this.error =
          "There was an error loading product manuals, please try again later";
      })
      .then(() => {
        this.loading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-sue7nhwz {
  padding: 6rem 0 5rem 0;
  background-color: #fff;

  .component {
    opacity: 0;

    &.is-active {
      animation: fade-in 2s ease;
      animation-fill-mode: forwards;
    }

    .stage {
      .items {
        display: flex;
        align-items: stretch;
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;

        &.-justify-content-center {
          @media (min-width: 992px) {
            justify-content: center;
          }
        }
      }

      .item {
        padding: 0 0.5rem;
        display: flex;
        flex-shrink: 0;
        align-items: stretch;
      }
    }

    .swiper {
      padding: 0 3.5rem;

      @media (min-width: 768px) {
        padding: 0;
        padding-left: 10px;
        padding-right: 10px;
      }
    }

    .seek-wrapper {
      position: absolute;
      z-index: 1;

      width: 30%;
      bottom: -42px;
      left: 50%;
      transform: translateX(-50%);

      @media (min-width: 992px) {
        width: 20%;
      }

      @media (min-width: 768px) and (max-width: 991px) {
        width: 100%;
        bottom: auto;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      @media (min-width: 1306px) {
        width: 100%;
        bottom: auto;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      a:nth-child(1) {
        float: left;
        transform: translateX(-3rem) scale(1.175);

        @media (min-width: 992px) {
          transform: translateX(-4rem) scale(1.4);
        }
      }

      a:nth-child(2) {
        float: right;
        transform: translateX(3rem) scale(1.175);

        @media (min-width: 992px) {
          transform: translateX(4rem) scale(1.4);
        }
      }
    }

    .-mode-xs,
    .-mode-sm {
      &.swiper-container {
        overflow: visible;
      }
    }

    .-mode-md,
    .-mode-lg,
    .-mode-xl {
      &.swiper-container {
        overflow: hidden;
      }
    }

    .swiper-container {
      position: relative;
      z-index: 1;
      width: 100%;
      height: 100%;

      margin: 0 auto;
      padding: 1rem 0 0.5rem 0;

      @media (min-width: 768px) {
        padding: 1rem 0 2rem 0;
      }
    }
  }
}
</style>